
export default {
    meeting: {},
    twilioToken: null,
    otherUser: {},
    endModal: {
        active: false,
        message: "Ședința s-a încheiat. Vă mulțumim!"
    },
    status: null, // pending, processing, done
    canReview: false,
    tipsThankyou: false,
    sidebarCounter: 0
}
